module.exports = __webpack_public_path__ + "img/TheMembers-6-pt.d682b8fa.png";